import { constants } from '../stores/OfferRequestStore';
import MessageClient from 'clients/messages';
import * as ExperiencesClient from '../clients/experiences';
import BookingsClient from '../clients/bookings';

import { postDryRunCustomTrip } from "../clients/bookings";

export default {
  offerrequest: {
    fetchOfferRequest(requestId) {
      this.dispatch(constants.FETCH_OFFER_REQUEST, { requestId });
      MessageClient.getDetailedOfferRequest(requestId)
        .then(response => {
          this.dispatch(constants.FETCH_OFFER_REQUEST_SUCCESS, { requestId, response });
        }).catch((e) => {
          console.warn(e);
          this.dispatch(constants.FETCH_OFFER_REQUEST_FAILED, { requestId });
        });
    },
    fetchOfferRequestFromTrip(tripId) {
      this.dispatch(constants.FETCH_OFFER_REQUEST, { requestId: tripId });
      BookingsClient.getOne(tripId)
        .then(response => {
          this.dispatch(constants.FETCH_OFFER_REQUEST_FROM_TRIP_SUCCESS, { requestId: tripId, response });
        }).catch((e) => {
          console.warn(e);
          this.dispatch(constants.FETCH_OFFER_REQUEST_FAILED, { requestId: tripId });
        });
    },
    fetchWlFee(experienceId, nrOfGuests, isOnline) {
      postDryRunCustomTrip(experienceId, nrOfGuests, isOnline)
        .then(response => {
          this.dispatch(constants.FETCH_WL_FEE_SUCCESS, { response });
        }).catch((e) => {
          console.warn(e);
          this.dispatch(constants.FETCH_WL_FEE_FAILED);
        });
    },
    setOfferRequestFromAccount(accountId) {
      this.dispatch(constants.FETCH_OFFER_REQUEST_FROM_ACCOUNT, { requestId: accountId });
    },
    fetchExperiences(accountId) {
      this.dispatch(constants.FETCH_EXPERIENCE_LISTING, { accountId });
      ExperiencesClient.fetchHostExperiences(accountId)
        .then(response => {
          this.dispatch(constants.FETCH_EXPERIENCE_LISTING_SUCCESS, { accountId, response });
        }).catch((e) => {
          console.error(e);
          this.dispatch(constants.FETCH_EXPERIENCE_LISTING_FAILED, { accountId });
        });
    },
    updateOfferTitle(title) {
      this.dispatch(constants.UPDATE_OFFER_TITLE, title);
    },
    updateOfferIsOnline(isOnline) {
      this.dispatch(constants.UPDATE_OFFER_ONLINE, isOnline);
    },
    updateOfferDescription(description) {
      this.dispatch(constants.UPDATE_OFFER_DESCRIPTION, description);
    },
    updateOfferGuests(numberOfAdults, numberOfChildren) {
      this.dispatch(constants.UPDATE_OFFER_GUESTS, { numberOfAdults, numberOfChildren });
    },
    updateOfferDateTime(date, time) {
      this.dispatch(constants.UPDATE_OFFER_DATE_TIME, { date, time });
    },
    updateOfferDutation(days, hours, minutes) {
      this.dispatch(constants.UPDATE_OFFER_DURATION, { days, hours, minutes });
    },
    updateOfferLists(included, excluded) {
      this.dispatch(constants.UPDATE_OFFER_LISTS, { included, excluded });
    },
    updateOfferPrice(price) {
      this.dispatch(constants.UPDATE_OFFER_PRICE, price);
    },
    updateOfferExperience(experience) {
      this.dispatch(constants.UPDATE_EXPERIENCE, experience);
    },
    updateOfferFullyPersonalized() {
      this.dispatch(constants.UPDATE_FULLY_PERSONALIZED, null);
    },
    updateMeetingPoint({ address, latLng, exactSpot, meetingPoint, meetOption }) {
      this.dispatch(constants.UPDATE_MEETING_POINT, { address, latLng, exactSpot, meetingPoint, meetOption });
    },
    setExperiences({ accountId, experiences }) {
      this.dispatch(constants.FETCH_EXPERIENCE_LISTING_SUCCESS, { accountId, experiences });
    },
    setOfferRequestDraft(draft) {
      this.dispatch(constants.SET_OFFER_REQUEST_DRAFT, draft);
    },
    clearOfferRequestDraft() {
      this.dispatch(constants.CLEAR_OFFER_REQUEST_DRAFT);
    },
  },
};
